<template>
    <section class="tables landing-page">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Seminar Items</h4>
                    </div>
                    <div class="card-body">
                        <form action="" method="post">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <div>
                                            <input id="search" name="search" v-model.trim="searchIndex.search" type="search" placeholder="Search"
                                                class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 form-group">
                                    <input type="button" @click="searchFn" class="btn btn-sm btn-primary" value="search">
                                </div>
                            </div>
                        </form>
                       <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            :totalRows="tableConfig.totalRecords" :isLoading="tableConfig.isLoading"
                            :pagination-options="tableConfig.options" :rows="packingList" :sort-options="{
                                enabled: false,
                            }" :columns="tableConfig.columns">

                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'action'">
                                    <button class="btn btn-sm btn-primary mr-3"
                                        @click="updateItem(props.row)">Edit</button>
                                    <button class="mt-1 btn btn-sm btn-danger"
                                        @click="deletePackingItems(props.row.itemID)">delete</button>
                                </span>
                                <span v-else-if="props.column.field == 'Marketing' || props.column.field == 'NewPatients' || props.column.field == 'Conversion' || props.column.field == 'Retention' || props.column.field == 'Revenue' || props.column.field == 'TeamDevelopment'">
                                    {{ (props.formattedRow[props.column.field]==1?'Yes':'No') }}
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                            
                        </vue-good-table>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<script>

import Vue from "vue";
import API from "@/api";
import Snotify, { SnotifyPosition } from 'vue-snotify'
import router from '../router';
import CircleLoader from '@/pages/loaders/CircleLoader.vue';
const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)

export default {
    data() {
        return {
            isLoading: false,
            searchIndex: {
                search: "",
                GroupID: 1,
                sort: [
                    {
                        field: 'email', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10
            },
            packingList: [],
            tableConfig: {
                columns: [
                    {
                        label: 'Qty',
                        field: 'Quantity',
                        type: 'number',
                    },
                    {
                        label: 'Item',
                        field: 'ItemName',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: "Description",
                        type: 'text',
                    },
                    {
                        label: '1',
                        field: "Marketing",
                        type: 'text',
                    },
                    {
                        label: '2',
                        field: "NewPatients",
                        type: 'text',
                    },
                    {
                        label: '3',
                        field: "Conversion",
                        type: 'text',
                    },
                    {
                        label: '4',
                        field: "Retention",
                        type: 'text',
                    },
                    {
                        label: '5',
                        field: "Revenue",
                        type: 'text',
                    },
                    {
                        label: '6',
                        field: "TeamDevelopment",
                        type: 'text',
                    },
                    {
                        label: 'Action',
                        field: "action",
                        type: 'text',
                    }
                ],
                options: {
                    enabled: true,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 20, 50, 100, 200],
                },
                totalRecords: 0,
                isLoading: false
            }
        }
    },
    methods: {
        searchFn(){
            this.allPackingItems();
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.allPackingItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.allPackingItems();
        },
        updateParams(newProps) {
            this.searchIndex = Object.assign({}, this.searchIndex, newProps);
            console.log('this.searchIndex :', this.searchIndex);
        },
        allPackingItems() {
            API.allPackingItems(this.searchIndex, this.allPackingItemsCB, this.errorCB)
        },
        allPackingItemsCB(res) {
            this.tableConfig.totalRecords = res.data.total;
            this.packingList = res.data.data
            this.isLoading = false;
        },
        updateItem(data){
            router.push({path:"/AdminSystem/edit_seminar/",name:'edit_seminar',params:{item:data}})
        },
        deletePackingItems(id){
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    console.log('id :', id);
                    API.deletePackingItems({id: id},this.deletePackingItemsCB,this.errorCB)
                    this.$swal(
                        'Deleted!',
                        'Record has been deleted.',
                        'success'
                    )
                }
            })
        },
        deletePackingItemsCB(res){
            this.allPackingItems();
            this.$showNotification(res,"success")
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({message:'Failed system error'},"error")
        },
    },
    mounted() {
        this.isLoading = true;
        this.allPackingItems()
    },
    watch:{
        'searchIndex.search' : function (newValue){
            if(newValue.trim() === ''){
                this.searchIndex.search = '';
                this.allPackingItems();
            }
        }
    }
}

</script>